export { is } from '@payloadcms/translations/languages/is'
